/*
  MIT License

  Copyright (c) 2022 Open Source  UOM

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all
  copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.

  Made by Open Source UoM (https://opensource.uom.gr)

  Project members:
    -Apostolidis
    -Davios
    -Iosifidis
    -Konstantinidis
    -Mpakalis
    -Nasis
    -Omiliades
    -Patsouras
    -Fakidis

*/

import i18n from "../../i18n"

const projectMembers = [
  {
    name: i18n.t("apostolidis"),
    socialMedia: "https://www.linkedin.com/in/geoapos/",
    email: "mailto:geoapostolidis999@gmail.com",
    img: "https://opensource.uom.gr/myuom_members_pics/apostolidis.jpg",
  },
  {
    name: i18n.t("davios"),
    socialMedia: "https://www.linkedin.com/in/evaggelos-davios/",
    email: "mailto:evaggelosdavios@gmail.com",
    img: "https://opensource.uom.gr/myuom_members_pics/davios.jpg",
  },
  {
    name: i18n.t("iosifidis"),
    socialMedia: "https://www.linkedin.com/in/eiosifidis/",
    email: "mailto:eiosifidis@gmail.com",
    img: "https://opensource.uom.gr/myuom_members_pics/iosifidis.jpg",
  },
  {
    name: i18n.t("konstantinidis"),
    socialMedia:
      "https://www.linkedin.com/in/konstantinos-konstantinidis-0b27a618a/",
    email: "mailto:it14228@uom.edu.gr",
    img: "https://www.uom.gr/site/images/personphoto-1.jpg",
  },
  {
    name: i18n.t("bakalis"),
    socialMedia:
      "https://www.linkedin.com/in/paraskevas-georgios-bakalis-6785591a9/",
    email: "mailto:parismpakalis@gmail.com",
    img: "https://opensource.uom.gr/myuom_members_pics/bakalis.jpg",
  },
  {
    name: i18n.t("nasis"),
    socialMedia: "https://www.linkedin.com/in/prodromos-nasis-223ba420b/",
    email: "mailto:prodromos.nasis@gmail.com",
    img: "https://opensource.uom.gr/myuom_members_pics/nasis.jpg",
  },
  {
    name: i18n.t("omiliadis"),
    socialMedia: "https://www.linkedin.com/in/socratesomiliadis/",
    email: "mailto:socrates@sohub.gr",
    img: "https://opensource.uom.gr/myuom_members_pics/omiliades.jpg",
  },
  {
    name: i18n.t("patsoyras"),
    socialMedia:
      "https://www.linkedin.com/in/%CF%87%CF%81%CE%AE%CF%83%CF%84%CE%BF%CF%82-%CF%86%CE%B1%CE%BD%CE%BF%CF%8D%CF%81%CE%B9%CE%BF%CF%82-%CF%80%CE%B1%CF%84%CF%83%CE%BF%CF%8D%CF%81%CE%B1%CF%82-3abb11250/",
    email: "mailto:xristos.patsoyras@gmail.com",
    img: "https://www.uom.gr/site/images/personphoto-1.jpg",
  },
  {
    name: i18n.t("fakidis"),
    socialMedia: "https://www.linkedin.com/in/fakidis-georgios-4a344a224/",
    email: "mailto:fakidis.george1@gmail.com",
    img: "https://www.uom.gr/site/images/personphoto-1.jpg",
  },
];

export default projectMembers;
